/**
 * Where a gRPC request's .proto is saved (card 5258c71d): relative to the
 * workspace folder when the workspace IS a folder and the file is inside it —
 * so the request works for everyone who clones that repository — else the
 * absolute path as picked.
 */
const norm = (p) => String(p || '').replace(/\\/g, '/').replace(/\/+$/, '');
const isAbsolute = (p) => /^([a-zA-Z]:\/|\/)/.test(norm(p));
const isWindowsPath = (p) => /^[a-zA-Z]:\//.test(p);

/** The workspace folder of a folder workspace, or null. */
export function workspaceFolderOf(workspace) {
  return workspace?.storage === 'git' && workspace.rootPath ? norm(workspace.rootPath) : null;
}

/** The form to save: relative inside the folder, absolute otherwise. */
export function protoPathToSave(absolutePath, folder) {
  if (!absolutePath) return null;
  const file = norm(absolutePath);
  const root = folder ? norm(folder) : null;
  if (!root) return file;
  const same = isWindowsPath(file)
    ? file.toLowerCase().startsWith(`${root.toLowerCase()}/`)
    : file.startsWith(`${root}/`);
  return same ? file.slice(root.length + 1) : file;
}

/** The absolute path to load; null when a relative path has no folder to resolve against. */
export function protoPathToLoad(saved, folder) {
  if (!saved) return null;
  if (isAbsolute(saved)) return norm(saved);
  return folder ? `${norm(folder)}/${norm(saved)}` : null;
}
